import { Store } from "interfaces/store";

type StoresByProjectPayload = { payload?: { data?: Store[] } };

interface ResolveStoreIdsOptions {
  projectId: number | string;
  storeIdsInState?: string;
  storesInContext?: Store[];
  fetchStoresByProjectId?: (...args: any[]) => Promise<any>;
}

export const getStoreIdsFromStores = (
  stores: Store[] = [],
  projectId?: number | string
): string => {
  if (!stores.length) {
    return "";
  }

  const hasProjectInfo = stores.some(
    (store) =>
      store.project_id !== undefined &&
      store.project_id !== null &&
      store.project_id !== ""
  );

  const scopedStores =
    hasProjectInfo && projectId !== undefined
      ? stores.filter((store) => String(store.project_id) === String(projectId))
      : stores;

  return scopedStores
    .map((store) => store.store_id)
    .filter((storeId): storeId is string => Boolean(storeId))
    .join(",");
};

export const resolveStoreIdsForProject = async ({
  projectId,
  storeIdsInState,
  storesInContext = [],
  fetchStoresByProjectId,
}: ResolveStoreIdsOptions): Promise<string> => {
  const normalizedStoreIds = (storeIdsInState || "").trim();
  if (normalizedStoreIds) {
    return normalizedStoreIds;
  }

  const storeIdsInContext = getStoreIdsFromStores(storesInContext, projectId);
  if (storeIdsInContext) {
    return storeIdsInContext;
  }

  if (!fetchStoresByProjectId) {
    return "";
  }

  const storesAction = await fetchStoresByProjectId(projectId);
  return getStoreIdsFromStores(storesAction?.payload?.data || [], projectId);
};